export default __webpack_public_path__ + "static/media/new6.694d3a35.png";